// extracted by mini-css-extract-plugin
export default {"quote":"Quotes_quote__96FNG","author":"Quotes_author__3Pm32"};